import { render, staticRenderFns } from "./PurchaseComponent.vue?vue&type=template&id=61617338&scoped=true"
import script from "./PurchaseComponent.vue?vue&type=script&lang=js"
export * from "./PurchaseComponent.vue?vue&type=script&lang=js"
import style0 from "./PurchaseComponent.vue?vue&type=style&index=0&id=61617338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61617338",
  null
  
)

export default component.exports